import { render, staticRenderFns } from "./DesktopHistory.vue?vue&type=template&id=33bfe8d2&scoped=true&"
import script from "./DesktopHistory.vue?vue&type=script&lang=js&"
export * from "./DesktopHistory.vue?vue&type=script&lang=js&"
import style0 from "./DesktopHistory.vue?vue&type=style&index=0&id=33bfe8d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bfe8d2",
  null
  
)

export default component.exports